import { ValidationModel, ValidationType } from "@/services/validation/types";

export const propertiesValidators = {
    wayfinderId: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};
